const { createAction } = require("../../helpers");
const {
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_RESET,
  GET_COUPON_ERROR,

  GET_COUPON_LIST,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_LIST_ERROR,
  GET_COUPON_LIST_RESET,

  GET_COUPON_SUGGESTION,
  GET_COUPON_SUGGESTION_SUCCESS,
  GET_COUPON_SUGGESTION_ERROR,
  GET_COUPON_SUGGESTION_RESET,

  APPLY_COUPON,
  APPLY_COUPON_SUCCESS,
  APPLY_COUPON_ERROR,
  APPLY_COUPON_RESET,
} = require("./constants");

const coupon = (id) => createAction(GET_COUPON, { id });

const couponSuccess = (data) => createAction(GET_COUPON_SUCCESS, { data });

const couponError = (error) => createAction(GET_COUPON_ERROR, { error });

const couponReset = () => createAction(GET_COUPON_RESET);

const couponList = (name) => createAction(GET_COUPON_LIST, { name });

const couponListSuccess = (data) =>
  createAction(GET_COUPON_LIST_SUCCESS, { data });

const couponListError = (error) =>
  createAction(GET_COUPON_LIST_ERROR, { error });

const couponListReset = () => createAction(GET_COUPON_LIST_RESET);

const couponSuggestion = ({ carts }) =>
  createAction(GET_COUPON_SUGGESTION, { carts });

const couponSuggestionSuccess = (data) =>
  createAction(GET_COUPON_SUGGESTION_SUCCESS, { data });

const couponSuggestionError = (error) =>
  createAction(GET_COUPON_SUGGESTION_ERROR, { error });

const couponSuggestionReset = () => createAction(GET_COUPON_SUGGESTION_RESET);
const applyForCoupon = ({ cartArray, couponCode, couponType }) =>
  createAction(APPLY_COUPON, { cartArray, couponCode, couponType });

const applyForCouponSuccess = (data) =>
  createAction(APPLY_COUPON_SUCCESS, { data });

const applyForCouponError = (error) =>
  createAction(APPLY_COUPON_ERROR, { error });

const applyForCouponReset = () => createAction(APPLY_COUPON_RESET);

module.exports = {
  coupon,
  couponSuccess,
  couponError,
  couponReset,

  couponList,
  couponListSuccess,
  couponListError,
  couponListReset,

  couponSuggestion,
  couponSuggestionSuccess,
  couponSuggestionError,
  couponSuggestionReset,

  applyForCoupon,
  applyForCouponSuccess,
  applyForCouponError,
  applyForCouponReset,
};
